import { render, staticRenderFns } from "./orders-cell.vue?vue&type=template&id=6180921a&scoped=true&"
import script from "./orders-cell.vue?vue&type=script&lang=js&"
export * from "./orders-cell.vue?vue&type=script&lang=js&"
import style0 from "./orders-cell.vue?vue&type=style&index=0&id=6180921a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6180921a",
  null
  
)

component.options.__file = "orders-cell.vue"
export default component.exports